module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/belle-shelton-a2edd52f2f147faf81078c19a013e84a.jpg";